import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { PreparationHDModel } from 'src/app/models/PreparationHDModel';
import { PreparationDetService } from 'src/app/services/PreparationDetService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { formatDate } from '@angular/common';
import { PreparationHDService } from 'src/app/services/PreparationHDService';


@Component({
  selector: 'app-preparationsearch',
  templateUrl: './preparationsearch.component.html',
  styleUrls: ['./preparationsearch.component.css']
})
export class PreparationsearchComponent implements OnInit {
  ProtocolCode = '';
  ProtocolDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  ProtocolExDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  paAge = 0;
  documentCode = '';
  paatintCode ='';
  patientFName ='';
  prHdCode = '';
  prHdName = '';
  docDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  excDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  cBcDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  docPhCode = '';
  prHdCycle = 0;
  prHdDays = 0;
  prHdNotes = '';
  prHdPulse = '0';
  prHdB_P = '0';
  prHdTemp = '0';
  prHdCBG = '0';
  prHdWeight = '0';
  prHdHeight = '0';
  prHdAge = 0;
  compCode = '1';
  paSycle = 0;
  userID = '';
  modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  preparationList: PreparationHDModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();

  constructor( public dialogRef: MatDialogRef<PreparationsearchComponent>,   ///----------- for searching pop up -----------
               public preparationHDService: PreparationHDService,
               public preparationHD: PreparationHDModel,
               public storage: LocalStorageService,
               @Inject(MAT_DIALOG_DATA)                                     ///----------- for searching pop up -----------
               public PreparationSelectedData: PreparationHDModel) { }

  ngOnInit(): void {this.retrivePrepTop()}
  retriveIPrepLookUp() {
    this.preparationList = [];
    this.preparationHDService.getPrepHDLookup(this.documentCode, this.paatintCode,  this.patientFName, this.compCode).subscribe((data: PreparationHDModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.preparationList[i] = data[i];
      data[i].docDate = formatDate(data[i].docDate, 'yyyy-MM-dd', 'en');
    }
 
  })
}
retrivePrepTop() {

  this.preparationHDService.getPrepHDLookupTop(this.compCode).subscribe((data: PreparationHDModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.preparationList[i] = data[i];
      data[i].docDate = formatDate(data[i].docDate, 'yyyy-MM-dd', 'en');
    }
    console.log(data);
  })
}

SelectItem(prep: PreparationHDModel){
  this.PreparationSelectedData.docNumber = prep.docNumber

  this.PreparationSelectedData.docDate = prep.docDate
  this.PreparationSelectedData.exDate= prep.exDate

  this.PreparationSelectedData.paIntCode= prep.paIntCode
  this.PreparationSelectedData.patientFName = prep.patientFName
  this.PreparationSelectedData.docCode = prep.docCode;
  this.PreparationSelectedData.docPhCode = prep.docPhCode;

  this.PreparationSelectedData.prepAge = prep.prepAge
  this.PreparationSelectedData.paGender= prep.paGender
  this.PreparationSelectedData.paBirthDate= prep.paBirthDate
  this.PreparationSelectedData.paProtocol= prep.paProtocol
  this.PreparationSelectedData.cancerType= prep.cancerType
  this.PreparationSelectedData.paDays = prep.paDays
  this.PreparationSelectedData.paSycle= prep.paSycle

  this.PreparationSelectedData.userID = prep.userID
  this.PreparationSelectedData.modifiedDate = prep.modifiedDate
  this.PreparationSelectedData.compCode = prep.compCode
  this.submitClicked.emit(this.PreparationSelectedData);

  this.dialogRef.close();
}
}
